export const USER_GROUPS = {
	MEMBER: '1',
	ADMIN: '2',
	CLIENT: '3',
	EMPLOYEE: '4',
};
